/**
 * Document permission levels for the document management system.
 * These define what actions users can perform on documents and folders.
 */
export enum DocumentPermission {
  /** Can view documents and folders */
  View = 'View',
  /** Can upload new documents */
  Upload = 'Upload',
  /** Can download documents */
  Download = 'Download',
  /** Can edit document metadata */
  Edit = 'Edit',
  /** Can delete documents */
  Delete = 'Delete',
  /** Can manage folder permissions */
  ManagePermissions = 'ManagePermissions',
  /** Can create sub-folders */
  CreateFolder = 'CreateFolder',
}

/**
 * Document scope types - determines the visibility level of documents
 */
export enum DocumentScope {
  /** System-wide documents visible to all franchises */
  System = 'System',
  /** Franchise-wide documents (training, policies, etc.) */
  Franchise = 'Franchise',
  /** Store-specific documents */
  Store = 'Store',
  /** Task evidence - captured during task completion */
  TaskEvidence = 'TaskEvidence',
}

/**
 * Document categories for organization
 */
export enum DocumentCategory {
  /** Training materials and guides */
  Training = 'Training',
  /** Company policies and procedures */
  Policies = 'Policies',
  /** Operational guides and SOPs */
  Operations = 'Operations',
  /** Compliance and regulatory documents */
  Compliance = 'Compliance',
  /** Marketing materials */
  Marketing = 'Marketing',
  /** Task evidence (photos, signatures, etc.) */
  Evidence = 'Evidence',
  /** General/uncategorized documents */
  General = 'General',
}

/**
 * Document types/formats supported
 */
export enum DocumentType {
  PDF = 'PDF',
  Image = 'Image',
  Video = 'Video',
  Document = 'Document', // Word docs, etc.
  Spreadsheet = 'Spreadsheet',
  Presentation = 'Presentation',
  Archive = 'Archive',
  Other = 'Other',
}
